export default {
  currency: {
    NIS: 1,
    USD: 2
  },
  invoiceStatuses: {
    CREATED: 0,
    PENDING: 10,
    COMPLETED: 20,
    COMPLETED_AND_TOKEN_CREATED: 21,
    RENEWED: 22,
    REFUNDED: 30,
    CANCELED: 40,
    ERROR: 50,
    CLOSED: 60,
    ARCHIVED: 70,
    CREATED_FOR_RENEW: 80
  },
  invoiceStatusesText: {
    CREATED: 'CREATED',
    PENDING: 'PENDING',
    COMPLETED: 'COMPLETED',
    COMPLETED_AND_TOKEN_CREATED: 'COMPLETED',
    RENEWED: 'RENEWED',
    REFUNDED: 'REFUNDED',
    CANCELED: 'CANCELED',
    ERROR: 'ERROR',
    CLOSED: 'COMPLETED',
    ARCHIVED: 'COMPLETED',
    CREATED_FOR_RENEW: 'RENEWED'
  },
  // invoiceStatusText: {
  //   0: 'CREATED',
  //   10: 'PENDING',
  //   20: 'COMPLETED',
  //   21: 'COMPLETED_AND_TOKEN_CREATED',
  //   22: 'RENEWED',
  //   30: 'REFUNDED',
  //   40: 'CANCELED',
  //   50: 'ERROR',
  //   60: 'CLOSED',
  //   70: 'ARCHIVED',
  //   80: 'CREATED_FOR_RENEW'
  // },
  invoiceStatusColors: {
    CREATED: 'info',
    PENDING: 'info',
    COMPLETED: 'success',
    COMPLETED_AND_TOKEN_CREATED: 'success',
    RENEWED: 'blue',
    REFUNDED: 'warning',
    CANCELED: 'grey',
    ERROR: 'error',
    CLOSED: 'success',
    ARCHIVED: 'success',
    CREATED_FOR_RENEW: 'blue'
    // 0: 'info',
    // 10: 'info',
    // 20: 'success',
    // 21: 'success',
    // 22: 'blue',
    // 30: 'warning',
    // 40: 'grey',
    // 50: 'error',
    // 60: 'success',
    // 70: 'success',
    // 80: 'blue'
  },
  userPackageStatus: {
    NoPackage: 0,
    ActivePackage: 1,
    ExpiredPackage: 2,
    ActiveTrialPackage: 3,
    ExpiredTrialPackage: 4
  },
  userPackageStatusText: {
    0: 'No Package',
    1: 'Active Package',
    2: 'Expired Package',
    3: 'Active Trial Package',
    4: 'Expired Trial Package'
  },
  userPackageStatusSelect: [
    { text: 'No Package', value: 0, shortText: 'None' },
    { text: 'Active Package', value: 1, shortText: 'Active' },
    { text: 'Expired Package', value: 2, shortText: 'Expired' },
    { text: 'Active Trial Package', value: 3, shortText: 'Trial' },
    { text: 'Expired Trial Package', value: 4, shortText: 'ExpTrial' }
  ]
}



// WEBPACK FOOTER //
// ./src/store/subscription/state.js